import { useMemo } from 'react';
import { DeviceResponseType as ChannelResponseType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import {
  BlindPositionDeviceState,
  BlindErrorDeviceState,
} from 'lavva.exalushome/build/js/Services/Devices/IDeviceState';

export const useBlindErrors = (channel: IDeviceChannel) => {
  const blindPositionState = useMemo(() => {
    return channel.States?.find((state) => state.TypeAsEnum === ChannelResponseType.BlindPosition) as
      | BlindPositionDeviceState
      | undefined;
  }, [channel.States]);

  const blindErrors = useMemo(() => {
    if (channel.GetDevice().AvailableResponseTypes.find((x) => x.Type === ChannelResponseType.BlindErrorState)) {
      return (
        channel.States?.filter(
          (state) => state.TypeAsEnum === ChannelResponseType.BlindErrorState,
        ) as BlindErrorDeviceState[]
      )
        .filter((x) => !x.Data.Reset)
        .map((x) => x.Data.ErrorCode);
    }

    return [];
  }, [channel.States]);

  return { blindPositionState, blindErrors };
};
